"use client";

import { useState } from "react";
import Link from "next/link";
import { Alert, Button, Card, Container, SimpleGrid, Stack, Text, TextInput, Title } from "@mantine/core";

export default function StyleClubAccessPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const recover = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (loading) return;
    setLoading(true);
    setError(null);
    try {
      const response = await fetch("/api/style-club/access", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: email.trim() }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "We could not send your link. Please try again.");
      setSent(true);
    } catch (failure) { setError(failure instanceof Error ? failure.message : "Check your connection and try again."); }
    finally { setLoading(false); }
  };
  return (
    <Container size="xl" py={48}>
      <SimpleGrid cols={{ base: 1, md: 2 }} spacing="xl">
        <Stack gap="md">
          <Title order={1}>Return to your Style Club</Title>
          <Text c="dimmed">Use the email address from your subscription. We’ll send a private link to your weekly looks, closet and AI stylist. No password needed.</Text>
          <Button component={Link} href="/style-club" variant="subtle" w="fit-content">Explore Style Club</Button>
        </Stack>
        <Card withBorder radius="lg" p="xl">
          <form onSubmit={recover}>
            <Stack gap="md">
              {error && <Alert color="red" role="alert">{error}</Alert>}
              {sent ? <Alert color="violet" role="status">If a membership matches that email, we’ll send your private access link. Check your inbox and spam folder.</Alert> : <>
                <TextInput label="Subscription email" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.currentTarget.value)} placeholder="you@example.com" />
                <Button type="submit" color="violet" loading={loading}>Email my private access link</Button>
              </>}
              <Text size="xs" c="dimmed">Need help? Email hi@coloranalysistech.com from your subscription email address.</Text>
            </Stack>
          </form>
        </Card>
      </SimpleGrid>
    </Container>
  );
}
